import styled from "styled-components";

export const Icon = styled.img`
  width: 18.5px;
  margin-left: 8.5px;
`;
